import { GlobalStore } from "@roc/feature-app-core";
import { DocReviewBaseStore } from "./docReviewBaseStore";
import { DocReviewInternalService } from "../service/docReviewInternalService";

export class DocReviewInternalStore extends DocReviewBaseStore {
  constructor(globalStore: GlobalStore) {
    super(globalStore);
    this.service = new DocReviewInternalService();
  }
}